import React from 'react';
import InterventionsCreate from '../InterventionsCreate';

const PanelScenarioCreateV1: React.FC = () => <InterventionsCreate embedded />;

export default PanelScenarioCreateV1;
